import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

const DeleteButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  padding: `10px ${theme.spacing(6)}px`,
  backgroundColor: theme.palette.error.light,
  color: theme.palette.common.black,
  border: `1px solid ${theme.palette.grey[600]}`,
  fontWeight: 700,
  position: 'relative',
  textTransform: 'capitalize',
  '& svg': {
    width: 0,
    height: 0,
    opacity: 0,
    transition: 'width 0.3s ease, height 0.3s ease, opacity 0.3s ease'
  },
  '&:hover': {
    fontWeight: 500,
    border: `1px solid ${theme.palette.error.main}`,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    '& svg': {
      width: 24,
      height: 24,
      opacity: 1
    }
  }
}))

export default DeleteButton
